'use client';
import React, { Component } from 'react';

import {
    listBottom,
    listDescription,
    listLayoutPage,
    listProcess,
    listResult,
    listSolution,
    listTask,
    listTeamCustomer,
} from './constants';

import FullWrapper from '../reusable-components/layouts-components__common-cases/full-wrapper';
import NextProject from '../reusable-components/layouts-components__common-cases/next-project';
import { getAdjacentCase } from '../../../../../shared/utilities/GetAdjacentCase/getAdjacentCase';
import Description from '../reusable-components/layouts-components__teboil/description';
import Design from '../reusable-components/layouts-components__teboil/design';
import LayoutPage from '../reusable-components/layouts-components__teboil/layout-page';
import Process from '../reusable-components/layouts-components__teboil/process';
import Result from '../reusable-components/layouts-components__teboil/result';
import Seo from '../reusable-components/layouts-components__teboil/seo';
import Solution from '../reusable-components/layouts-components__teboil/solution';
import Target from '../reusable-components/layouts-components__teboil/target';
import Task from '../reusable-components/layouts-components__teboil/task';
import Team from '../reusable-components/layouts-components__teboil/team';
import TeamCustomer from '../reusable-components/layouts-components__teboil/team-customer';
import Testing from '../reusable-components/layouts-components__teboil/testing';
import Title from '../reusable-components/layouts-components__teboil/title';
import Integrations from '../reusable-components/layouts-components__teboil/integrations';
import CommonNav from '../common-components/common-nav';
import ScrollAnimation from '../../../../../core/ScrollAnimation';
import OfferButton from '../../../../../shared/sections/OfferButton';

class Teboil extends Component {
    render() {
        const casePathname = '/cases/development/teboil';
        const adjacentCase = getAdjacentCase(casePathname);

        return (
            <section>
                <CommonNav
                    stepOne="Главная"
                    stepTwo="Кейсы"
                    stepThree="Разработка"
                    link1={'/'}
                    link2={'/cases'}
                    link3={true}
                />
                <Title listBottom={listBottom} />
                <Target />
                <Task listTask={listTask} />
                <Description listDescription={listDescription} />
                <Solution listSolution={listSolution} />
                <Process listProcess={listProcess} />
                <Design />
                <LayoutPage listLayoutPage={listLayoutPage} />
                <Seo />
                <Integrations />
                <Testing />
                <Result listResult={listResult} />
                <Team />
                <TeamCustomer listTeamCustomer={listTeamCustomer} />
                <ScrollAnimation>
                    <FullWrapper>
                        <OfferButton linkText="Нанять команду" />
                    </FullWrapper>
                </ScrollAnimation>
                {adjacentCase && (
                    <NextProject
                        NextProject={{
                            nextProjectTitle: adjacentCase.case.title,
                            nextProjectImg: adjacentCase.case.image,
                            nextProjectLink: adjacentCase.case.router,
                            nextProjectText: adjacentCase.case.description,
                            nextProjectLabel: adjacentCase.label,
                        }}
                    />
                )}
            </section>
        );
    }
}

export default Teboil;
